export const encodeToBase64 = (text) => new Buffer(text).toString('base64');
